import Text from '@atoms/Text';
import Link from '@atoms/Link';
import { useRouter } from 'next/router';
import Button from '@ui/atoms/design-system/Button';
import Image from '@atoms/Image';
import texts from './en.json';
import { cn } from '@ui/helpers/utils';

const ProductFAQs = ({
    selectedProduct,
    onButtonClick,
    vectorClassname = '',
    exploreButtonVisible = true,
    middleBodyClassName = 'relative mt-2 w-full flex flex-col items-center py-12 md:pt-34 xl:pt-28 md:pb-36',
}) => {
    const { productFaqs } = selectedProduct;

    const router = useRouter();
    const faqURL = (title) => {
        switch (title) {
            case 'Corporate Debt':
                return 'corporate-and-venture-debt';
            case 'Venture Debt':
                return 'corporate-and-venture-debt';
            case 'Invoice Discounting':
                return 'invoice-discounting';
            case 'Asset Backed Leasing':
                return 'asset-backed-leasing';
            default:
                return '';
        }
    };
    return (
        <section
            id={`product-faq`}
            className={cn(
                'flex flex-col items-center w-full md:pt-12 xl:pt-4 md:h-x-small font-heading',{
                    "pt-12" : exploreButtonVisible
                }
            )}
        >
            {exploreButtonVisible ? (
                <Button
                    buttonSize="small"
                    buttonType="primary"
                    buttonText={selectedProduct?.banner?.bannerButton}
                    onClick={onButtonClick}
                />
            ) : null}
            <div className={middleBodyClassName}>
                <Text
                    content={texts.haveMoreQuestions}
                    htmlTag="h2"
                    className="p3-semibold md:h4-semibold text-primary-500"
                />
                <Text
                    content={texts.checkoutFaq}
                    htmlTag="p"
                    className="mt-1 text-gray-800 p5-regular md:p4-regular"
                />
                <Button
                    buttonType="outline"
                    buttonSize="small"
                    buttonText={texts.viewFaq}
                    onClick={() => {
                        router.push(`/faq/#${faqURL(selectedProduct?.title)}`);
                    }}
                    className="mt-3 md:mt-6"
                />
                <div
                    className={`absolute top-24 md:top-0 left-8 md:left-24 xl:left-36 ${vectorClassname}`}
                >
                    <Image
                        src={productFaqs?.bgImage}
                        alt="faq"
                        className="w-[118px] h-[125px] md:w-[304px] md:h-[331px]"
                    />
                </div>
            </div>
            <div className="w-full z-50 mt-2 mb-4 px-6 xl:px-18 mx-auto text-gray-500 p6-regular">
                <Text htmlTag="label" content={texts.riskDisclaimer} />
                <Link
                    href="/risk-disclosure"
                    children=" https://www.altgraaf.com/risk-disclosure "
                    className="p6-medium"
                />
                <Text htmlTag="label" content={texts.beforeInvestment} />
            </div>
        </section>
    );
};

export default ProductFAQs;
